import * as React from "react";

import Button, { ButtonProps } from "@mui/material/Button";
import Typography, {
    TypographyProps as MuiTypographyProps,
} from "@mui/material/Typography";

import useIntercom from "../hooks/useIntercom";

type Props = ButtonProps & {
    preText?: string;
    TypographyProps?: MuiTypographyProps;
    /**
     * Prefills the messenger's first message. Pass it wherever the caller
     * already knows what the user is stuck on, so they don't retype it for the
     * agent.
     */
    message?: string;
    /**
     * Called when the user chooses to message a human. This is the "we didn't
     * answer it ourselves" signal — the inverse of support deflection — so
     * callers that measure deflection need to log it here. Fired regardless of
     * whether the messenger is available, because the user's intent to escalate
     * is the thing being measured.
     */
    onEscalate?: () => void;
};

export default function SupportLink({
    TypographyProps = {},
    preText = "",
    message,
    onEscalate,
    children,
    ...props
}: Props): React.JSX.Element {
    const intercom = useIntercom();
    return (
        <Typography
            variant="body2"
            align="center"
            sx={{ my: 2 }}
            {...TypographyProps}
        >
            {`${preText ?? ""} `}
            <Button
                {...props}
                type="button"
                onClick={() => {
                    onEscalate?.();
                    intercom.newMessage(message);
                }}
                variant="text"
                color="info"
            >
                {children}
            </Button>
        </Typography>
    );
}
